module.exports = __webpack_public_path__ + "static/media/videoEditor-10.7df8771e.webp";